module.exports = __webpack_public_path__ + "img/万达美好物业APP隐私协议3757.cdc80382.png";